/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener(
      "dispatch:cart-drawer:open",
      this.openDrawerViaEventHandler
    );
    document.addEventListener(
      "dispatch:cart-drawer:close",
      this.closeDrawerViaEventHandler
    );
    document.addEventListener(
      "dispatch:cart-drawer:refresh",
      this.cartRefreshHandler
    );
    this.addEventListener("on:cart-drawer:before-open", () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll("cc-cart-cross-sell").forEach((el) => el.init());
    });
    this.addEventListener("on:cart:after-merge", () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll("cc-cart-cross-sell").forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener(
      "dispatch:cart-drawer:refresh",
      this.cartRefreshHandler
    );
    document.removeEventListener(
      "dispatch:cart-drawer:open",
      this.openDrawerViaEventHandler
    );
    document.removeEventListener(
      "dispatch:cart-drawer:close",
      this.closeDrawerViaEventHandler
    );
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector("cart-form").refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector("cart-form").refreshFromHtml(html);
  }
}

window.customElements.define("cart-drawer", CartDrawer);

// document.addEventListener('DOMContentLoaded', function () {
// Get all variant selects on the page

// var cart_drawer_icon = document.querySelector(".cart-link");
// var cart_drawer_open = document.querySelector("cart-drawer[open]");

// cart_drawer_icon.addEventListener('click', function(){

//     setTimeout(() => {

//     document.querySelectorAll('.upsell-select').forEach(function (select) {

//       select.addEventListener('change', function (e) {
//         const selectedVariantId = this.value;

//         // Find the parent form
//         const form = this.closest('.upsell-form');
//       console.log("selectedVariantId===",selectedVariantId);
//         if (form) {
//           // Find the hidden input inside this form and update its value
//           const hiddenInput = form.querySelector('input[type="hidden"][name="id"]');
//           if (hiddenInput) {
//             hiddenInput.value = selectedVariantId;
//           }
//         }
//       });
//     });
//   }, 1000);

// });

// document.addEventListener("DOMContentLoaded", function () {
//   var cart_form_ele = document.querySelector("cart-form");
//   console.log("cart-form====", cart_form_ele);

//   const cartDrawerTrigger = document.querySelector(".cart-link");

//   // Open cart drawer and attach upsell listeners
//   cartDrawerTrigger.addEventListener("click", function () {
//     setTimeout(() => {
//       start1();
      
//       function start1(){
      
//       document.querySelectorAll(".upsell-select").forEach(function (select) {
//         select.addEventListener("change", function () {
//           const selectedVariantId = this.value;
//           const form = this.closest(".upsell-form");
//           console.log("form---", form);
//           if (form) {
//             const hiddenInput = form.querySelector(
//               'input[type="hidden"][name="id"]'
//             );
//             if (hiddenInput) hiddenInput.value = selectedVariantId;
//           }
//         });
//       });

//         start2();
//       }
//       // Attach AJAX submission to upsell forms
//       // document.addEventListener("DOMContentLoaded", function () {
      
      

//       function start2(){
        
//       document.querySelectorAll(".upsell-form").forEach(function (form) {
//         const submitButton = form.querySelector(".upsell-add-btn");
//         console.log("submitButton--", submitButton);
//         if (submitButton) {
//           submitButton.addEventListener("click", function (e) {
//             e.preventDefault();

//             const formData = new FormData(form);

//             fetch("/cart/add.js", {
//               method: "POST",
//               headers: {
//                 Accept: "application/json",
//               },
//               body: formData,
//             })
//               .then((response) => {
//                 if (!response.ok) throw new Error("Add to cart failed");
//                 return response.json();
//               })
//               .then((data) => {
//                 console.log("Upsell product added:", data);
//                 cart_form_ele.boundRefresh();
//                 start1();
//                 // Now reload the cart drawer section HTML
//               })
//               .catch((error) => {
//                 console.error("Error adding upsell product:", error);
//               });
//           });
//         }
//       });
//       }
        
//       // });
//     }, 1000);
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const cartDrawerTrigger = document.querySelector(".cart-link");

  // Attach click listener to open cart drawer
  cartDrawerTrigger.addEventListener("click", function () {
    setTimeout(() => {
      initUpsellListeners();
    }, 1000);
  });

  function initUpsellListeners() {
    attachVariantChangeHandler();
    attachUpsellFormSubmitHandler();
  }

  function attachVariantChangeHandler() {
    document.querySelectorAll(".upsell-select").forEach(function (select) {
      if (!select.hasAttribute("data-bound")) {
        select.addEventListener("change", function () {
          const selectedVariantId = this.value;
          const form = this.closest(".upsell-form");
          // console.log("form---", form);
          if (form) {
            const hiddenInput = form.querySelector('input[type="hidden"][name="id"]');
            if (hiddenInput) hiddenInput.value = selectedVariantId;
          }
        });
        select.setAttribute("data-bound", "true"); // prevent duplicate listeners
      }
    });
  }

  function attachUpsellFormSubmitHandler() {
    const cart_form_ele = document.querySelector("cart-form");

    document.querySelectorAll(".upsell-form").forEach(function (form) {
      const submitButton = form.querySelector(".upsell-add-btn");

      if (submitButton && !submitButton.hasAttribute("data-bound")) {
        submitButton.addEventListener("click", function (e) {
          e.preventDefault();

          const formData = new FormData(form);

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
            },
            body: formData,
          })
            .then((response) => {
              if (!response.ok) throw new Error("Add to cart failed");
              return response.json();
            })
            .then((data) => {
              // console.log("Upsell product added:", data);

              // Refresh cart content (if drawer already open)
              if (cart_form_ele && typeof cart_form_ele.boundRefresh === "function") {
                cart_form_ele.boundRefresh();
              }

              // Re-initialize listeners after refresh
              setTimeout(() => {
                initUpsellListeners();
              }, 2000);
            })
            .catch((error) => {
              console.error("Error adding upsell product:", error);
            });
        });

        submitButton.setAttribute("data-bound", "true"); // prevent re-binding
      }
    });
  }
});
